/* Group Chat Goods — theme scripts (no dependencies) */
(function () {
  'use strict';

  var routes = window.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };

  /* ---------------------------------------------------------------------- */
  /* Sticky header                                                           */
  /* ---------------------------------------------------------------------- */
  function initHeader() {
    var wrapper = document.querySelector('[data-header]');
    if (!wrapper) return;
    var update = function () {
      wrapper.classList.toggle('is-scrolled', window.scrollY > 8);
      var rect = wrapper.getBoundingClientRect();
      document.documentElement.style.setProperty('--header-bottom', Math.max(rect.bottom, 0) + 'px');
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    var mobile = document.querySelector('[data-mobile-menu]');
    if (mobile) {
      mobile.addEventListener('toggle', function () {
        document.body.classList.toggle('drawer-open', mobile.open);
        update();
      });
    }

    // Close desktop dropdowns when clicking elsewhere or pressing Escape
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.site-nav__dropdown[open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.site-nav__dropdown[open]').forEach(function (d) {
        d.removeAttribute('open');
        var s = d.querySelector('summary');
        if (s) s.focus();
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Cart drawer                                                             */
  /* ---------------------------------------------------------------------- */
  var lastFocus = null;

  function getDrawer() { return document.getElementById('CartDrawer'); }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var panel = drawer.querySelector('.drawer__panel');
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = String(count) === '0';
    });
  }

  function renderDrawer(html) {
    var drawer = getDrawer();
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-drawer-content]');
    var current = drawer.querySelector('[data-drawer-content]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var countEl = doc.querySelector('[data-item-count]');
    if (countEl) updateCartCount(countEl.getAttribute('data-item-count'));
  }

  function initDrawer() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-cart]');
      if (opener && getDrawer() && getDrawer().hasAttribute('data-enabled')) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-close-cart]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      var change = e.target.closest('[data-cart-change]');
      if (change) {
        e.preventDefault();
        changeLine(change.getAttribute('data-line'), parseInt(change.getAttribute('data-quantity'), 10));
      }
    });
    document.addEventListener('keydown', function (e) {
      var drawer = getDrawer();
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  function changeLine(line, quantity) {
    var drawer = getDrawer();
    var body = drawer ? drawer.querySelector('[data-drawer-content]') : null;
    if (body) body.classList.add('is-loading');
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(quantity, 0), sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections) renderDrawer(data.sections['cart-drawer']);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .catch(function () { window.location.href = routes.cart; })
      .finally(function () { if (body) body.classList.remove('is-loading'); });
  }

  /* ---------------------------------------------------------------------- */
  /* Add to cart                                                             */
  /* ---------------------------------------------------------------------- */
  function initProductForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-product-form]');
      if (!form) return;
      var drawer = getDrawer();
      if (!drawer || !drawer.hasAttribute('data-enabled')) return; // fall back to the cart page

      e.preventDefault();
      var button = e.submitter || form.querySelector('[type="submit"]');
      var errorEl = form.querySelector('[data-form-error]');
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }

      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer');
      formData.append('sections_url', window.location.pathname);

      fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (errorEl) { errorEl.textContent = res.json.description || res.json.message || 'Something went wrong. Try again.'; errorEl.hidden = false; }
            return;
          }
          if (res.json.sections) renderDrawer(res.json.sections['cart-drawer']);
          openDrawer();
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (button) { button.removeAttribute('aria-busy'); button.disabled = button.hasAttribute('data-unavailable'); }
        });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Variant pickers (product page + product cards)                          */
  /* ---------------------------------------------------------------------- */
  function initVariantPicker(root) {
    var dataEl = root.querySelector('script[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var idInput = root.querySelector('input[name="id"]');
    var button = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var colorLabel = root.querySelector('[data-color-label]');
    var inventoryEl = root.querySelector('[data-inventory]');
    var updateUrl = root.hasAttribute('data-update-url');
    var scope = root.closest('[data-product-scope]') || root;

    function selected() {
      var values = [];
      root.querySelectorAll('[data-option-index]').forEach(function (el) {
        var i = parseInt(el.getAttribute('data-option-index'), 10);
        if (el.tagName === 'SELECT' || el.type === 'hidden') values[i] = el.value;
        else if (el.checked) values[i] = el.value;
      });
      return values;
    }

    function find(values) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return values[i] === undefined || values[i] === opt; });
      });
    }

    function markAvailability(values) {
      root.querySelectorAll('input[data-option-index]').forEach(function (input) {
        var i = parseInt(input.getAttribute('data-option-index'), 10);
        var test = values.slice();
        test[i] = input.value;
        var match = variants.some(function (v) {
          return v.available && v.options.every(function (opt, j) { return test[j] === undefined || test[j] === opt; });
        });
        input.classList.toggle('is-unavailable', !match);
      });
      root.querySelectorAll('[data-quick-index]').forEach(function (btn) {
        var i = parseInt(btn.getAttribute('data-quick-index'), 10);
        var test = values.slice();
        test[i] = btn.value;
        var match = variants.some(function (v) {
          return v.available && v.options.every(function (opt, j) { return test[j] === undefined || test[j] === opt; });
        });
        btn.disabled = !match;
      });
    }

    function update() {
      var values = selected();
      var variant = find(values);

      var checkedColor = root.querySelector('input[data-swatch]:checked');
      if (checkedColor) {
        if (colorLabel) colorLabel.textContent = checkedColor.value;
        scope.querySelectorAll('[data-garment]').forEach(function (g) {
          g.style.setProperty('--garment', checkedColor.getAttribute('data-hex'));
          g.style.setProperty('--garment-ink', checkedColor.getAttribute('data-ink'));
        });
      }

      markAvailability(values);

      if (!variant) {
        if (button) { button.disabled = true; button.setAttribute('data-unavailable', ''); button.textContent = button.getAttribute('data-unavailable-text') || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price_html;
      if (button) {
        button.disabled = !variant.available;
        if (variant.available) button.removeAttribute('data-unavailable'); else button.setAttribute('data-unavailable', '');
        button.textContent = variant.available ? (button.getAttribute('data-add-text') || 'Add to bag') : (button.getAttribute('data-sold-out-text') || 'Sold out');
      }
      if (inventoryEl) {
        inventoryEl.textContent = variant.inventory_note || '';
        inventoryEl.hidden = !variant.inventory_note;
      }
      if (variant.image) {
        var img = scope.querySelector('[data-primary-image]');
        if (img) { img.src = variant.image; img.removeAttribute('srcset'); }
      }
      if (updateUrl && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });
    // Quick add size buttons: pick that option value, then let the form submit.
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-index]');
      if (!btn) return;
      var hidden = root.querySelector('input[type="hidden"][data-option-index="' + btn.getAttribute('data-quick-index') + '"]');
      if (hidden) hidden.value = btn.value;
      update();
    });
    update();
  }

  /* ---------------------------------------------------------------------- */
  /* Quantity steppers                                                       */
  /* ---------------------------------------------------------------------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      var input = btn.closest('.quantity').querySelector('input');
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-qty-step'), 10);
      var min = parseInt(input.getAttribute('min') || '0', 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Featured collection filter pills                                        */
  /* ---------------------------------------------------------------------- */
  function initFilterPills() {
    document.querySelectorAll('[data-filter-pills]').forEach(function (group) {
      var section = group.closest('section');
      var items = section ? section.querySelectorAll('[data-type]') : [];
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('[data-filter]');
        if (!pill) return;
        var f = pill.getAttribute('data-filter');
        group.querySelectorAll('[data-filter]').forEach(function (p) { p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
        items.forEach(function (item) {
          item.hidden = !(f === 'all' || item.getAttribute('data-type') === f);
        });
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Collection filters + sorting                                            */
  /* ---------------------------------------------------------------------- */
  function initFacets() {
    document.querySelectorAll('form[data-facets]').forEach(function (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="number"]')) return;
        form.submit();
      });
    });
    document.querySelectorAll('[data-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Product recommendations                                                 */
  /* ---------------------------------------------------------------------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            el.innerHTML = fresh.innerHTML;
            el.querySelectorAll('[data-variant-picker]').forEach(initVariantPicker);
          } else {
            el.closest('section') && (el.closest('section').hidden = true);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------------------------------------------------------------------- */
  function init() {
    initHeader();
    initDrawer();
    initProductForms();
    initQuantity();
    initFilterPills();
    initFacets();
    initRecommendations();
    document.querySelectorAll('[data-variant-picker]').forEach(initVariantPicker);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-initialise sections when edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-variant-picker]').forEach(initVariantPicker);
    initFilterPills();
    initHeader();
  });

  window.GCG = { openCart: openDrawer, closeCart: closeDrawer };
})();
